var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "417px",
    viewBox: "0 0 256 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#343434",
    points: "127.9611 0 125.1661 9.5 125.1661 285.168 127.9611 287.958 255.9231 212.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    points: "127.962 0 0 212.32 127.962 287.959 127.962 154.158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3C3C3B",
    points: "127.9611 312.1866 126.3861 314.1066 126.3861 412.3056 127.9611 416.9066 255.9991 236.5866"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    points: "127.962 416.9052 127.962 312.1852 0 236.5852"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#141414",
    points: "127.9611 287.9577 255.9211 212.3207 127.9611 154.1587"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#393939",
    points: "0.0009 212.3208 127.9609 287.9578 127.9609 154.1588"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/ethereum-icon.c729bd46b192b8ea53dcc0d30b14ad9e.svg";
export { ForwardRef as ReactComponent };